/** 2022 CODATA / SI exact values where applicable. */
export const CONSTANTS = Object.freeze({
  speedOfLight: 299_792_458,
  planck: 6.626_070_15e-34,
  reducedPlanck: 1.054_571_817e-34,
  boltzmann: 1.380_649e-23,
  vacuumPermittivity: 8.854_187_8188e-12,
  vacuumPermeability: 1.256_637_061_27e-6,
  fineStructureConstant: 7.297_352_564_3e-3,
  electronMass: 9.109_383_713_9e-31,
  elementaryCharge: 1.602_176_634e-19,
  pi: Math.PI
});
